import { createAction, props } from '@ngrx/store';

import { Crop } from '../../shared/model';

export const loadCropsRequest = createAction('[Crop] Load crops request');

export const loadCropsSuccess = createAction(
  '[Crop] Load crops success',
  props<{ crops: Crop[] }>(),
);
